import React from 'react';

import Switch from '~/App/Components/Switch';
import QuestionTooltip from '~/App/Components/QuestionTooltip';
import {
  startUpgradeModalFlow,
  StartUpgradeModalFlowProps,
} from '../Modals/UpgradeModalFlow';
import { UpgradeModalTrigger } from '../Modals/UpgradeModalFlow/util';
import { Service } from '~/types/models';
import cx from 'classnames';
import usePlandalfCheckoutSuccess from '~/react-hooks/use-plandalf-checkout-success';
import { usePlandalfGate } from '~/plandalf/use-plandalf-gate';
import { hasBrandingAccess } from '~/plandalf/gates';

export interface RemoveBonjoroBadgeSwitchProps
  extends Pick<
    StartUpgradeModalFlowProps,
    | 'onBeforeRedirect'
    | 'onPaymentSuccess'
    | 'upgradeModalNote'
    | 'successModalNote'
    | 'onClose'
  > {
  className?: string;
  toolTipText?: string;
  textClassName?: string;
  service?: Service;
  onClick?: () => void;
}

export default function RemoveBonjoroBadgeSwitch({
  className = '',
  textClassName,
  toolTipText = 'Remove the "Powered by Bonjoro" badge from your video landing pages so you can be on brand.',
  service,
  onClick,
  upgradeModalNote,
  successModalNote,
  onBeforeRedirect,
  onPaymentSuccess,
  onClose,
}: RemoveBonjoroBadgeSwitchProps) {
  const { trigger: triggerPlandalfGate } = usePlandalfGate();

  usePlandalfCheckoutSuccess({});

  const showRemoveBonjoroBadgeUpgradeModal = async () => {
    const result = await triggerPlandalfGate('branding', hasBrandingAccess);
    if (result.state === 'allowed' || result.state === 'legacy') {
      onClick?.();
      return;
    }
    if (result.state !== 'manual') {
      onClick?.();
      return;
    }

    startUpgradeModalFlow({
      trigger:
        service === Service.VideoMessaging
          ? UpgradeModalTrigger.MessageTemplateRemoveBonjoroBadge
          : UpgradeModalTrigger.TestimonialsRemovePoweredByBonjoro,
      upgradeModalNote,
      successModalNote,
      onBeforeRedirect,
      onPaymentSuccess,
      onClose,
      reason: 'User wants to remove the Bonjoro badge',
    });

    onClick?.();
  };

  return (
    <>
      <div className={cx(className, 'flex justify-between')}>
        <div className={cx(textClassName, 'text-neutral-600')}>
          Remove Bonjoro Badge &nbsp;
          <QuestionTooltip id='bonjoro-badge' hoverText={toolTipText} />
        </div>
        <Switch value={false} onClick={showRemoveBonjoroBadgeUpgradeModal} />
      </div>
    </>
  );
}
